<template>
    <Transition name="slide-down-transition">
        <slot v-if="show"></slot>
    </Transition>
</template>

<script setup lang="ts">
    const show = ref<boolean>(false);

    onMounted(() => {
        if (show) show.value = true;
    })
</script>
  